import React, { useState, startTransition } from 'react';
import Modal from 'react-bootstrap/Modal';
import user from '../../assets/user.png';
import arrow from '../../assets/arrow.png';
import Singleemployee from './Singleemployee';

import Multipleemployee from './Multipleemployee'; // Import the Multipleemployee component

function Employeeconnect(props) {
  const [showSingleEmployeeModal, setShowSingleEmployeeModal] = useState(false);
  const [showMultipleEmployeeModal, setShowMultipleEmployeeModal] = useState(false);

  const openSingleEmployeeModal = () => {
    startTransition(() => {
      setShowSingleEmployeeModal(true);
    });
  };

  const openMultipleEmployeeModal = () => {
    startTransition(() => {
      setShowMultipleEmployeeModal(true);
    });
  };

  const closeSingleEmployeeModal = () => {
    setShowSingleEmployeeModal(false);
  };

  const closeMultipleEmployeeModal = () => {
    setShowMultipleEmployeeModal(false);
  };

  // ... other code

  return (
    <Modal {...props} aria-labelledby="contained-modal-title-vcenter">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Select option</Modal.Title>
      </Modal.Header>
      <Modal.Body className="grid-example">
        <button className="multiple-option d-flex align-items-center mt-4" onClick={openSingleEmployeeModal}>
          <div className='bulk-users mr-3'><img src={user} alt="bulk-users" /></div>
          <div className="option-title">
            <h5 className='multiple-text'>Add single employee</h5>
            <p className="link-class2">Tap to onboard a single employee</p>
          </div>
          <div className='arrow-icon ml-auto'><img src={arrow} alt="arrow-icon" /></div>
        </button>

        <button className="multiple-option d-flex align-items-center mt-4" onClick={openMultipleEmployeeModal}>
          <div className='bulk-users mr-3'><img src={user} alt="bulk-users" /></div>
          <div className="option-title">
            <h5 className='multiple-text'>Add multiple employees</h5>
            <p className="link-class2">Tap to onboard employees in bulk</p>
          </div>
          <div className='arrow-icon ml-auto'><img src={arrow} alt="arrow-icon" /></div>
        </button>
      </Modal.Body>
      <Modal.Footer>
        {/* You can add a "Close" button here if needed */}
      </Modal.Footer>
      <Modal show={showSingleEmployeeModal} onHide={closeSingleEmployeeModal}>
        <Singleemployee show={showSingleEmployeeModal} onHide={closeSingleEmployeeModal} />
      </Modal>
      <Modal show={showMultipleEmployeeModal} onHide={closeMultipleEmployeeModal}>
        <Multipleemployee show={showMultipleEmployeeModal} onHide={closeMultipleEmployeeModal} />
      </Modal>
    </Modal>
  );
}

export default Employeeconnect;
